<template>
  <div class="app">
    <div class="content">
      <div style="display: flex;align-items: center;">
				<img src="../assets/img/header/logo-icon.png" alt="" />
				<div style="height: 60px;margin-top: 10px;">
					<div style="font-size: 22px;font-weight: 700;height: 28px;line-height: 40px;">吉 时 达</div>
					<div style="color: #ccc;font-size: 11px;height: 20px;line-height: 26px;">同城配送物流解决方案</div>
				</div>
			</div>
      <div class="content-right">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          ref="menu"
          :default-active="activeIndex"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="item in navList"
            :key="item.active"
            :index="item.active"
            style="padding: 0;min-width: 100px;"
          >
            <a
              class="a-style"
              style="display: inline-block;width: 100%;text-align: center;text-decoration: none;"
              :href="item.path"
              >{{ item.name }}</a
            >
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "0",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
          active: "0",
          id: 0,
        },
        {
          name: "物流服务",
          path: "/service.html",
          children: [],
          active: "1",
          id: 1,
        },
          {
              name: "行业实践",
              path: "/industries.html",
              children: [],
              active: "4",
              id: 4,
          },
          {
              name: "系统介绍",
              path: "/system.html",
              children: [],
              active: "5",
              id: 5,
          },
        {
          name: "商务洽谈",
          path: "/franchise.html",
          children: [],
          active: "2",
          id: 2,
        },
        {
          name: "关于我们",
          path: "/about.html",
          children: [],
          active: "3",
          id: 3,
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == "/parcel" || to.hash == "#ele1") {
        this.activeIndex = "1";
      } else if (to.hash == "#ele0") {
        this.activeIndex = "0";
      } else if (to.hash == "#ele2") {
        this.activeIndex = "2";
      } else if (to.hash == "#ele3") {
        this.activeIndex = "3";
      } else if (to.hash == "#ele4") {
          this.activeIndex = "4";
      } else if (to.hash == "#ele5") {
          this.activeIndex = "5";
      } else {
        this.activeIndex = null;
      }
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 960px) and (max-width: 1400px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .content {
    padding-right: 10%;
  }
}
@media screen and (min-width: 1400px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .content {
    padding-right: 350px;
  }
}

.app {
  min-width: 1000px;
  width: 100%;
  background: #fff;
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 99;
  .content {
    padding-left: 57px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    line-height: 60px;

    img {
      // width: 210px;
      //  height: 38px;
      image-rendering: -webkit-optimize-contrast;
    }
    // .content-right {
    //   display: flex;
    //   align-items: center;
    // }
  }
}
.el-menu--horizontal > .el-menu-item:nth-child(1) {
  margin-right: auto;
}
.el-menu--horizontal > .el-menu-item {
  color: #4e5969;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #084fff;
  color: #084fff;
}
.el-menu.el-menu--horizontal {
  border: none;
}
</style>
